import { render } from "./classroom-join.vue?vue&type=template&id=1ad90d90"
import script from "./classroom-join.vue?vue&type=script&lang=ts"
export * from "./classroom-join.vue?vue&type=script&lang=ts"
script.render = render

export default script